import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

const ImageHeading = (props) => {
  const { children, className } = props;

  return <h4 className={`image-heading ${className}`}>{children}</h4>;
};

ImageHeading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired,
};

export default ImageHeading;
